<template>
    <div class="contract">
        <v-dialog content-class="white" persistent v-model="progressLoad" max-width="80px">
            <v-progress-circular :size="50" indeterminate color="blue"></v-progress-circular>
        </v-dialog>
        <Header active="Contracts" />
        <TopSection :heading="`${contractId ? renewContract ? 'Renew' : 'Edit' : 'Add'} Contract`"
                    :subheading="`${contractId ? contractTitle : ''}`"
                    user="J K"
                    :hideSearch=true />
        <v-dialog v-model="success" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon @click="$router.push(`/contracts/${companyId}`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">Contract successfully {{ deleted ? 'deleted' : renewContract ? 'renewed' :contractId ? 'edited' : 'created'}}</span>
            </div>
        </v-dialog>
        <v-dialog v-model="errorDialog" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon @click="$router.push(`/contracts/${companyId}`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">An error has occurred.</span>
            </div>
        </v-dialog>
        <v-form ref="form" lazy-validation v-model="valid">
            <v-container class="pt-3" grid-list-lg>
                <v-layout row wrap>
                    <v-flex xs12 sm4 xl2 class="license-type-wrapper form-section">
                        <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Licence Type</span>
                        </div>
                        <v-select height=66
                                  id = "contract-type-id"
                                  background-color="white"
                                  color="primary"
                                  attach
                                  :items="contractTypes"
                                  label="Licence Type"
                                  v-model="selectedLicense"
                                  v-validate="contractId ? '' : 'required'"
                                  data-vv-name="selectedLicense"
                                  :error-messages="errors.collect('selectedLicense')"
                                  item-text="description"
                                  item-value="id"
                                  :single-line=true
                                  append-icon="keyboard_arrow_down"
                                  v-bind:disabled="disableSelectedLicense"
                                  required
                                  solo></v-select>
                    </v-flex>
                    <v-flex xs12 sm8 xl10 class="form-section">
                        <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Description</span>
                        </div>
                        <v-textarea flat
                                    solo
                                    v-bind:disabled="disableDescription" 
                                    rows=9
                                    :counter="500"
                                    no-resize
                                    v-model="description"
                                    placeholder="Descriptive text detailing who the licences are for"
                                    class="mb-1">
                        </v-textarea>
                    </v-flex>

                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md4 xl2 class="mb-2">
                        <div class="standard-height blue py-4 px-4 relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Number of Licences</span>
                        </div>
                        <div class="standard-height white relative pl-4">
                            <vue-numeric-input 
                                v-model="contractLicense" 
                                controls-type="updown"
                                v-bind:disabled="disableContractLicens" 
                                :min=1
                                :max=10000
                                :counter="10000"
                                v-validate="'required|min_value:1'"
                                data-vv-name="numberOfLicense"
                                :error-messages="errors.collect('numberOfLicense')"
                            ></vue-numeric-input>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2 class="mb-2">
                        <div class="standard-height blue py-4 px-4 relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Valid From</span>
                        </div>
                        <div class="standard-height white relative pl-4 date-picker__from">
                            <span :v-model="fromPicker" class="primary--text pl-3 standard-lh">{{ formattedData(fromPicker)}}</span>
                            <button type="button" class="cc__box-shadow square-button pull-right" @click="showCalendar('from')"  v-bind:disabled="disableFromPicker">
                                <v-icon color="black">date_range</v-icon>
                            </button>
                            <div :class="`${show.from ? '' : 'hide'}`">
                                <v-date-picker scrollable @input="show.from = !show.from" header-color="blue" full-width v-model="fromPicker" :min="minDate"></v-date-picker>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2 class="mb-2">
                        <div class="standard-height blue py-4 px-4 relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Valid To</span>
                        </div>
                        <div class="standard-height white relative pl-4">
                            <span :v-model="toPicker" class="primary--text pl-3 standard-lh">{{ formattedData(toPicker) }}</span>
                            <button type="button" class="cc__box-shadow square-button pull-right" @click="showCalendar('to')" v-bind:disabled="disableToPicker">
                                <v-icon color="black">date_range</v-icon>
                            </button>
                            <div :class="`${show.to ? '' : 'hide'}`">
                                <v-date-picker scrollable @input="show.to = !show.to" header-color="blue" full-width v-model="toPicker" :min="minDate"></v-date-picker>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex v-if="contractId" xl6 :class="`${contractId} contract-checkboxes`">
                        <v-checkbox
                            label="Disable Licences"
                            required
                            dark--text
                            large
                            v-bind:disabled="disableCheckbox" 
                            class="large font-weight-bold cc__checkbox mr-3 mb-2 mt-2"
                            v-model="isDisabled">
                        </v-checkbox>

                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-5 pt-1" v-if="userType == 1">
                    <v-flex xs12 sm6 md4 xl2>
                        <v-btn @click="submit" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">{{contractId ? extendContract ? 'Renew contract' : 'Save Changes' : 'Create Contract'}}</span>
                            <v-icon right class="white--text title">{{contractId ? 'save' : 'add'}}</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2>
                        <v-btn @click="$router.push(`/contracts/${companyId}`)" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Cancel</span>
                        </v-btn>
                    </v-flex>
                    <v-flex v-if="showRenewContract" xs12 sm6 md4 xl2>
                        <v-btn :href="`/extend-contract/${contractId}`" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Renew Contract</span>
                            <v-icon right class="white--text title">file_copy</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex v-if="contractId" xs12 sm6 md4 xl2>
                        <v-btn v-if="!renewContract" @click="dialog = true; deleteDialog = true;" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Delete</span>
                            <v-icon right class="white--text title">delete</v-icon>
                        </v-btn>
                        <v-dialog v-if="deleteDialog" persistent v-model="dialog" max-width="520">
                            <div class="notification-heading standard-height blue pr-4">
                                <v-icon @click="$router.push(`/contracts/${companyId}`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
                            </div>
                            <v-card class="pt-4 pb-3">
                                <v-card-title class="justify-center subtitle primary--text font-weight-bold">Do you really want to delete?</v-card-title>
                                <v-card-actions>
                                    <v-btn class="white--text" color="grey lighten-1" grey @click="dialog = false">Cancel </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn class="white--text" color="grey lighten-1" grey @click="submit('delete')">Confirm</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                </v-layout>
                 <v-layout row wrap class="mt-5 pt-1" v-if="userType != 1">
                     <v-flex xs12 sm6 md4 xl2>
                        <v-btn @click="$router.push(`/contracts/${companyId}`)" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Back</span>
                        </v-btn>
                    </v-flex>
                 </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    let show = {
        from: false,
        to: false
    }
    let selectedLicense = ''

    import contractService from "../services/contract"
    import TopSection from '../components/TopSection.vue'
    import Header from '../components/Header.vue'
    import router from '../router'
    import moment from 'moment'
    import VueNumericInput from 'vue-numeric-input';
    import VeeValidate from 'vee-validate'
    import Vue from 'vue'

    Vue.use(VeeValidate);

    export default {
        name: 'App',
        components: {
            Header, TopSection,
            'vue-numeric-input': VueNumericInput
        },
        $_veeValidate: {
            validator: 'new'
        },
        mounted() {
            this.$validator.localize('en', this.dictionary)
        },
        data() {
            return {
                errorDialog: false,
                progressLoad: false,
                deleteDialog: false,
                userType: sessionStorage.userType,
                valid: false,
                dialog: false,
                contractTypes: null,
                extendContract: false,
                contractId: this.$route.params.id,
                companyId: sessionStorage.companyId,
                contractTitle: '',
                contractData: [],
                fromPicker: new Date().toISOString().substr(0, 10),
                toPicker: new Date().toISOString().substr(0, 10),
                show,
                dictionary: {
                    custom: {
                        startDate: {
                            required: () => 'Contract start date is required'
                        },
                        endDate: {
                            required: () => 'Contract end date is required'
                        },
                        selectedLicense: {
                            required: () => 'Contract licence type is required'
                        },
                        numberOfLicense: {
                            required: () => 'Contract number of license > 0'
                        },
                    }
                },
                selectedLicense: null,
                success: false,
                description: '',
                contractLicense: 1,
                isDisabled: false,
                deleted: false,
                disableCheckbox: false,
                disableSelectedLicense: false,
                disableContractLicens: false,
                disableFromPicker: false,
                disableToPicker: false,
                disableDescription: false,
                renewContract: false,
                showRenewContract: false,
                minDate: new Date().toISOString().substr(0, 10),
            }
        },
        methods: {
            formattedData(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            async fetchData() {
                this.contractTypes = await contractService.getTypes();
                this.contractTypes = this.contractTypes.data;
                if (this.contractId) {
                    this.disableSelectedLicense = true;
                    this.disableFromPicker = true;
                    this.disableContractLicens  = true;
                    this.disableToPicker = true;
                   await contractService.fetchCompanyById(this.contractId)
                    .then(res => {
                        this.contractData = res;
                        this.description = this.contractData.data.description;
                        this.contractTitle = this.contractData.data.companyName  + ' - ' + this.contractId;
                        this.selectedLicense = {
                            id: this.contractData.data.contractTypeId
                        }; 
                        this.contractLicense = this.contractData.data.totalLicences;
                        this.toPicker = new Date(this.contractData.data.endDate).toISOString().substr(0, 10);
                        this.fromPicker = new Date(this.contractData.data.startDate).toISOString().substr(0, 10);
                        this.isDisabled = this.contractData.data.isDisabled;
                        if ( !this.contractData.data.hasExtension  &&  new Date() <= new Date(this.toPicker) ) {
                            this.showRenewContract = true;
                        }
                        })
                    .catch(err => {
                        if(err.status == 404){
                            router.push("/contracts/" + this.companyId);
                        }
                    });
                    
                    
                }else{
                    this.selectedLicense =  this.contractTypes[0].id;
                }
                if(this.$route.name == 'extend-contract'){
                    this.renewContract = true;
                    this.extendContract = true;
                    this.showRenewContract = false;
                    this.disableContractLicens  = false;
                    this.disableToPicker = false;
                    this.fromPicker = this.toPicker;
                    var date = new Date(this.contractData.data.endDate);
                    var dd = date.getDate() + 2;
                    var mm = date.getMonth() + 1;
                    var y = date.getFullYear();
                    this.minDate = new Date(y + '-'+ mm + '-'+ dd).toISOString().substr(0, 10);
                    this.toPicker =  new Date(y + '-'+ mm + '-'+ dd).toISOString().substr(0, 10);
                }     
                if(this.userType != 1){
                    this.disableDescription = true;
                    this.disableCheckbox = true;
                }
            },
            showCalendar(type) {
                this.show[type] = true
            },
            async submit(event) {
                if(this.contractLicense == 0){
                    this.$validator.errors.add({field : 'numberOfLicense', msg : "Contract number of license > 0"});
                }
                this.$validator.validate().then(result => {
                    if (result) { 
                        this.progressLoad = true;
                        if(this.extendContract){
                            contractService.renewContract(this.contractId, {
                                'endDate': this.toPicker,
                                'totalLicences': this.contractLicense,
                                'description': this.description,
                            }).then(res => {
                                this.progressLoad = false;
                                if (res.data.status == 1) {
                                    this.success = true;
                                    this.renewContract = true;
                                }
                            }).catch(err => {
                                this.progressLoad = false;
                                this.errorDialog = true;
                            });
                        } else {
                            this.deleteDialog = false;
                            if (this.contractId) {
                                if (event == 'delete') {
                                    contractService.delete(this.contractId)
                                        .then(res => {
                                            this.progressLoad = false;
                                            if (res.data.status == 1) {
                                                this.success = true;
                                                this.deleted = true;
                                            }
                                        }).catch(err => {
                                            this.errorDialog = true;
                                        });
                                } else {
                                    contractService.update(this.contractId, {
                                        'companyId': this.companyId,
                                        'isDisabled': this.isDisabled,
                                        'description': this.description,
                                    }).then(res => {
                                         this.progressLoad = false;
                                        if (res.data.status == 1) {
                                            this.success = true;
                                        }
                                    }).catch(err => {
                                         this.progressLoad = false;
                                         this.errorDialog = true;
                                    });
                                }

                            } else {
                                contractService.create({
                                    'startDate': this.fromPicker,
                                    'endDate': this.toPicker,
                                    'totalLicences': this.contractLicense,
                                    'contractType': this.selectedLicense,
                                    'companyId': this.companyId,
                                    'isDisabled': false,
                                    'description': this.description,
                                }).then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                    }
                                }).catch(err => {
                                     this.progressLoad = false;
                                     this.errorDialog = true;
                                });
                            }
                        }
                    }
                });
            }
        },
        created() {
            this.fetchData();
        }
    }

</script>

